import React from 'react';
import moment from 'moment';
import qs from 'qs';

import { getImageExtensionFromBase64 } from 'helpers/common';
import { formatPhone, formatDocument, capitalizeString } from 'helpers/formatters';

import '../../../../components/ExportPDF/templates/fonts/Roboto-Regular.ttf';

const VehicleDamageExport = React.forwardRef((props, ref) => {
  const { content, qp, establishmentId, establishment } = props?.data || {};
  const establishmentAddresses = establishment?.addresses?.length > 0 ? establishment?.addresses[0] : {};

  const plate = qs.parse(qp)?.plate || '';
  const os = qs.parse(qp)?.serviceOrderCode || '';

  const lineQnt = 2;

  const contentArray = content?.reduce((resultArray, item, index) => { 
    const chunkIndex = Math.floor(index / lineQnt)

    if(!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [];
    }

    resultArray[chunkIndex].push(item);

    return resultArray;
  }, []);

  const Header = ({ establishmentData }) => {
    const base64LogoExtension = getImageExtensionFromBase64(establishmentData?.base64Logo);

    if(!establishmentId) {
      return(
        <div style={{ width: '100%', borderBottom: '1px solid #E2E2E2' }}>
          <b>
            <p style={{ color: '#505050', fontSize: 20 }}>Todos os estabelecimentos</p>
          </b>
          {!!plate && (
            <p style={{ color: '#505050', fontSize: 20 }}>Placa: {plate}</p>
          )}
          {!!os && (
            <p style={{ color: '#505050', fontSize: 20 }}>OS: {os}</p>
          )}
        </div>
      );
    }

    return(
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: 10,
          padding: 10,
          borderBottom: '1px solid #E2E2E2'
        }}
      >
        {!!establishmentData.base64Logo && (
          <div style={{ width: '30%', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', padding: 10 }}>
            <img
              src={`data:image/${base64LogoExtension};base64,${establishmentData?.base64Logo}`}
              style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
            />
          </div>
        )}
        <div style={{ width: !!establishmentData.base64Logo ? '70%' : '100%' }}>
          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'row'
          }}>
            <div style={{ width: '100%', display: 'grid', gridTemplateColumns: 'repeat(2, 2fr)' }}>
              {!!establishmentData?.establishmentName && (
                <b>
                  <p style={{ color: '#505050', fontSize: 20, margin: 0 }}>{establishmentData?.establishmentName}</p>
                </b>
              )}
              {!!establishmentData?.phone && (
                <p style={{ color: '#505050', fontSize: 20, margin: 0 }}>Telefone: {formatPhone(establishmentData?.phone)}</p>
              )}
              {!!establishmentData?.documentId && (
                <p style={{ color: '#505050', fontSize: 20, margin: 0 }}>CNPJ: {formatDocument(establishmentData?.documentId)}</p>
              )}
              {!!establishmentData?.email && (
                <p style={{ color: '#505050', fontSize: 20, margin: 0 }}>Email: {establishmentData?.email}</p>
              )}
            </div>
          </div>
          <div style={{ width: '100%' }}>
            {!!establishmentData?.street && (
              <p style={{ color: '#505050', fontSize: 20 }}>Endereço: {establishmentData?.street}, {establishmentData?.number} - {establishmentData?.district} {establishmentData?.city}/{establishmentData?.state}</p>
            )}
            {!!plate && (
              <p style={{ color: '#505050', fontSize: 20 }}>Placa: {plate}</p>
            )}
            {!!os && (
              <p style={{ color: '#505050', fontSize: 20 }}>OS: {os}</p>
            )}
          </div>
        </div>
      </div>
    );
  }

  return(
    <div ref={ref} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontFamily: 'Roboto, sans-serif', padding: 10 }}>
      {!!establishment && (
        <Header establishmentData={{ ...establishment, ...establishmentAddresses }} />
      )}
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', marginTop: 15 }}>
        {contentArray?.map(content => {
          return(
            <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
              {content?.map(item => {
                return(
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', width: '50%', marginTop: 20 }}>
                    {!!item?.photoUrl ? (
                      <div style={{ height: 135, width: '50%' }}>
                        <img
                          src={item?.photoUrl}
                          style={{ width: 'auto', height: '100%' }}
                        />
                      </div>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', height: 135, width: '50%', backgroundColor: '#D4D4D4', border: 'solid 1px #505050' }}>
                        <h3 style={{ color: '#505050' }}>Sem Foto</h3>
                      </div>
                    )}
                    <div style={{ display: 'flex', flexDirection: 'column', height: 135, width: '100%', padding: '5px 0 0 10px', backgroundColor: '#F3F3F3', border: 'solid 1px #E4E4E4' }}>
                      {(!!item?.typeName || !!item?.partName) && (
                        <p style={{ margin: 0, color: '#505050', fontSize: 16 }}>
                          <b>
                            {capitalizeString(`${item?.typeName} ${item?.partName}`)}
                          </b>
                        </p>
                      )}
                      {!!item?.partName && (
                        <p style={{ margin: 0, color: '#505050', fontSize: 16 }}>
                          Área: {item?.partName}
                        </p>
                      )}
                      {!!item?.categoryName && (
                        <p style={{ margin: 0, color: '#505050', fontSize: 16 }}>
                          Parte: {item?.categoryName}
                        </p>
                      )}
                      {!!item?.typeName && (
                        <p style={{ margin: 0, color: '#505050', fontSize: 16 }}>
                          Tipo: {item?.typeName}
                        </p>
                      )}
                      {!!item?.registerDateTime && (
                        <p style={{ margin: 0, color: '#505050', fontSize: 16 }}>
                          Data de Criação: {moment(item?.registerDateTime).format('DD/MM/YYYY HH:mm:ss')}
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default VehicleDamageExport;